export const logParseErrors = (period: string) => {
  console.log(`Ошибка при парсинге периода: ${period}`);
};
